import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as me from '../../feature'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import type * as models from './models'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages all the current core contexts, such as current tenant, zone, app,
 * scenario, etc.
 */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /**
   * Stores tenant & zone access dates
   */
  public readonly localStorage = new store.storage.included.LocalStorage({
    parent: this,
    properties: {
      /**
       * Used to sort tenants & zones by most recent access date
       */
      lastAccessTimesByAlias: store.storage.lookup<
        models.ScopedAlias,
        number | undefined
      >({}),
    },
  })

  constructor(parent: me.Feature) {
    const _router = ngCore.inject(router.Router)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Contexts',
      parent,
      selectors: () => new Selectors(this, parent, _router),
    })

    this.registerEffects(
      effects.ensureCompleteRoute(parent, _router),
      effects.recordAccessTimes(),
      effects.startGetZoneApps(parent),
    )
  }
}
